import type {
  Game,
  GameCategory,
  SubGameCategory,
} from '@repo-level/core-front';
import { createItems } from '@repo-level/core-front';
import type {
  CMSCountryParams,
  CMSGroupParams,
  CMSScheduler,
} from 'api/cms/base';

export enum GameRecommendationCategories {
  Favorites = 'favorites',
  Recent = 'recent',
}

export interface UpdatedGameCategory
  extends GameCategory,
    CMSScheduler,
    CMSGroupParams,
    CMSCountryParams {
  description: string | undefined;
  icon?: string;
  order: number;
  href: string;
  filterTitle?: string;
  showOnLobby: boolean | null;
  subCategories: SubGameCategory[];
}

export const providersInvertLogo = [
  'mascot',
  'spribe',
  'baddingo',
  'jaderabbit',
  'petersons',
  'relax',
];

export enum GameErrorType {
  NotFound = 0,
  NotAvailCurrency = 1,
  NotAuthenticated = 2,
}

export const getGamesPlugs = (
  gamesList: Game[],
  gamesPerRow: number,
  slidesPerView: number,
  options?: {
    onlyFirstRow?: boolean;
  }
) => {
  if (options?.onlyFirstRow && gamesList.length >= slidesPerView) {
    return [];
  }

  const gridArea = gamesPerRow * Math.ceil(slidesPerView);

  let numberOfGamesPlug =
    gamesList.length <= gridArea
      ? gridArea - gamesList.length
      : gamesList.length % gridArea;

  if (gamesList.length > gridArea) {
    if (numberOfGamesPlug === gamesList.length) {
      return [];
    }

    if (numberOfGamesPlug >= gamesPerRow) {
      numberOfGamesPlug = numberOfGamesPlug % gamesPerRow;
    } else if (numberOfGamesPlug > 0) {
      numberOfGamesPlug = gamesPerRow - numberOfGamesPlug;
    }
  }

  const gamesPlug = createItems({}, numberOfGamesPlug);

  return gamesPlug as Game[];
};

export const filterGames = (games: Game[], category: string) =>
  games
    .filter(({ listCollections }) => listCollections.includes(category))
    .sort((a, b) => a.collections[category] - b.collections[category]);

export const getLocalizedCategoryId = (
  gameCategories: UpdatedGameCategory[],
  category: string
) =>
  gameCategories.find(({ id }) => new RegExp(`^${category}`).test(id))?.id ||
  category;
